import React, { useState } from "react";
import { ReactComponent as IncrementIcon } from "../../../svg/add-2.svg";
import { ReactComponent as DecrementIcon } from "../../../svg/minus-sign.svg";

export function LessonCounter({ min, max, label, inputName }) {
    const [count, setCount] = useState(min);
    const increment = function () {
        setCount(count + 1);
    }
    const decrement = function () {
        setCount(count - 1);
    }
    return (
        <span className="lesson-counter">
            <input type="hidden" name={inputName} value={count} />
            <span className="text">
                <span className="count">{count}</span>
                <span className="label">{label}</span>
            </span>
            <span className="buttons">
                <button type="button" className="btn btn-increment" onClick={increment} disabled={count === max}>
                    <IncrementIcon />
                </button>
                <button type="button" className="btn btn-decrement" onClick={decrement} disabled={count === min}>
                    <DecrementIcon />
                </button>
            </span>
        </span>
    );
}